"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SENSOR = exports.PRODUCT_ID_PHYSICAL = exports.GB_CURRENCY = void 0;
var PRODUCT_ID_PHYSICAL = exports.PRODUCT_ID_PHYSICAL = 'physical';
var SENSOR = exports.SENSOR = 'sensor';
var GB_CURRENCY = exports.GB_CURRENCY = 'GBP';